<template>
    <div class="map sticky-top">
        <!-- Map -->
        <GmapMap
        ref="mapRef"
        :center="center"
        :options="options"
        :zoom="12"
        @dragend="dragged">
            <!-- <gmap-cluster> -->
                <gmap-custom-marker
                    :class="['property-pin-container', marker.item && centerProperty && centerProperty.id === marker.item.id ? 'focused' : null]"
                    :marker="marker"
                    :key="index"
                    v-for="(marker, index) in markers"
                    @click.native="() => centerProperty = marker.item"
                    >
                    <div class="property-pin" :class="{ 'focused': marker.item && centerProperty && centerProperty.id === marker.item.id }">
                        <span class="emoji" v-if="! marker.item || (marker.item && ! marker.item.from_price)">🛏</span>
                        <span class="price" v-if="marker.item && marker.item.from_price">
                            {{ marker.item.from_price.total | formatPrice }}
                            &euro;
                        </span>
                    </div>
                    <!-- <destination-map-marker
                        :icon="marker.icon"
                        :label="marker.label"
                        :fill-color="marker.fillColor"
                        :stroke-color="marker.strokeColor"></destination-map-marker> -->
                </gmap-custom-marker>
            <!-- </gmap-cluster> -->

            <!-- Polygon -->
            <gmap-polygon :path="convertedPolygon" v-if="convertedPolygon"></gmap-polygon>
        </GmapMap>
    </div>
</template>

<script>
    import mapStyles from './../../destinatiosnMapStyles.json'
    import GmapCustomMarker from 'vue2-gmap-custom-marker';
    import DestinationMapMaker from './../../DestinationMapMarker.vue'
    import {gmapApi} from 'vue2-google-maps'

    export default {
        props: ['places', 'polygon', 'centerProperty'],
        components: {
            'gmap-custom-marker': GmapCustomMarker,
            'destination-map-marker': DestinationMapMaker,
            // 'gmap-cluster': Cluster,
        },
        data() {
            return {
                center: { lat: 48.160910, lng: 16.383330 },
            }
        },
        mounted() {
            var self = this
        },
        computed: {
            google: gmapApi,
            convertedPolygon() {
                if (! this.polygon || (this.polygon && ! this.polygon.coordinates)) {
                    return null
                }

                return this.polygon.coordinates[0].map((point) => {
                        return {
                            lat: point[0],
                            lng: point[1],
                        }
                })
            },
            markers() {
                var markers = []

                markers = markers.concat(this.places.map((place) => {
                    return {
                        type: 'primary',
                        lat: place.location.latitude,
                        lng: place.location.longitude,
                        icon: 'fa fa-home-alt',
                        item: place,
                        fillColor: '#1ABCB2',
                        strokeColor: '#129E95',
                    }
                }))

                // Set center
                // if (this.places.length > 0) {
                //     this.center = {
                //         lat: this.places[0].location.latitude,
                //         lng: this.places[0].location.longitude,
                //     }
                // }

                return markers
            },

            options() {
                return {
                    styles: mapStyles,
                    disableDefaultUI: true,
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: true,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false,
                }
            }
        },
        methods: {
            distance(lat1, lon1, lat2, lon2, unit) {
                if ((lat1 == lat2) && (lon1 == lon2)) {
                    return 0;
                } else {
                    var radlat1 = Math.PI * lat1/180;
                    var radlat2 = Math.PI * lat2/180;
                    var theta = lon1-lon2;
                    var radtheta = Math.PI * theta/180;
                    var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
                    if (dist > 1) {
                        dist = 1;
                    }
                    dist = Math.acos(dist);
                    dist = dist * 180/Math.PI;
                    dist = dist * 60 * 1.1515;
                    dist = dist * 1.609344
                    return dist;
                }
            },
            dragged() {
                var self = this
                this.$refs.mapRef.$mapPromise.then((map) => {
                    // self.google.maps.event.addListener(map, 'dragend', (event) => {
                        var ne = map.getBounds().getNorthEast()
                        var sw = map.getBounds().getSouthWest()

                        self.$emit('loadMapProperties', [{
                            latitude: sw.lat(),
                            longitude: ne.lng(),
                        },
                        {
                            latitude: ne.lat(),
                            longitude: ne.lng(),
                        },
                        {
                            latitude: ne.lat(),
                            longitude: sw.lng(),
                        },
                        {
                            latitude: sw.lat(),
                            longitude: sw.lng(),
                        },
                        {
                            latitude: sw.lat(),
                            longitude: ne.lng(),
                        }])
                })
            },
            refreshMapZoom() {
                var self = this

                if (! this.$refs && this.$refs.mapRef) {
                    return;
                }

                this.$refs.mapRef.$mapPromise.then((map) => {
                    // With center property
                    if (self.centerProperty) {
                        var zoom = map.getZoom();
                        map.setZoom(zoom < 12 ? 12 : zoom);

                        map.panTo({
                            lat: self.centerProperty.location.latitude,
                            lng: self.centerProperty.location.longitude,
                        })
                    }

                    // Without center property
                    if (self.centerProperty === null && self.markers.length > 0) {
                        var bounds = new self.$window.google.maps.LatLngBounds();
                        for (let i = 0; i < self.markers.length; i++) {
                            bounds.extend(self.markers[i]);
                        }
                        map.fitBounds(bounds)
                        map.panToBounds(bounds)
                    }
                    // if (self.markers.length > 1) {


                    //     // var zoom = map.getZoom();
                    //     // map.setZoom(zoom > 12 ? 12 : zoom);
                    // } else if (self.markers.length <= 1 && self.center) {
                    //     map.panTo(self.center)
                    // }

                    // console.log(map)
              })

                // if (this.centerProperty) {
                //     this.center = {
                //         lat: this.centerProperty.location.latitude,
                //         lng: this.centerProperty.location.longitude,
                //     }
                // }
            },
        },
        watch: {
            polygon() {
                var self = this
                this.$refs.mapRef.$mapPromise.then((map) => {
                    console.log('WRITE POLYGON')
                    if (self.polygon) {
                        const { Polygon } = self.google.maps
                        let paths = self.convertedPolygon
                        let polygon = new Polygon({
                            paths: paths,
                            strokeColor: '#FF0000',
                            strokeOpacity: 0.8,
                            strokeWeight: 20,
                            fillColor: '#FF0000',
                            fillOpacity: 0.7,
                        });
                        polygon.setMap(map);
                    }
                });
            },
            center() {

            },
            centerProperty() {
                this.refreshMapZoom()
            },
            markers() {
                this.refreshMapZoom()
            },
        }
    }
</script>
